import { useState } from "react"
import { useFormType } from "../../../../form/hooks/useForm";
import { CardStyle } from "../../../../styles/card";
import { TipoOperacao } from "../../../Obras/newObra/IObra";

import { OperacaoExternaDisplay } from "./OperacaoExternaDisplay/OperacaoExternaDisplay";


type OperacaoDisplayInput = {
    pecaEntrega: any,
    pecaEntregaId: number,
    operacao: any,
    key: number,
    idx: number,
    openIndex: number,
    pecaIdx: number,
    expeditionIndex: number,
    setExpeditionIndex: any,
    form: useFormType,
    setPecasToDisplay: any
}


export default function OperacaoDisplay({ pecaEntrega, pecaEntregaId, operacao, key, idx,openIndex, pecaIdx,expeditionIndex, setExpeditionIndex,  form, setPecasToDisplay }:
    OperacaoDisplayInput) {

        console.log("Operação is: ", operacao);

    return (
        <div className="bg-zinc-600 rounded-md p-5 text-white text-lg my-3">
            <h3 className="text-[1.4em] font-bold mb-4">Operação {operacao.id} {operacao.isExternal ? '(Externa)' : null}</h3>
            <hr/>
            <div className="my-4">
                <p><span className="font-bold mb-3">Observações:</span> {operacao.observacoes}</p>
                {operacao.medida? <p><span className="font-bold">Medida:</span> {operacao.medida}</p> : null}
            </div>
            {operacao.isExternal && operacao.tipo != TipoOperacao.SERROTE ? <OperacaoExternaDisplay 
                pecaEntrega={pecaEntrega}
                idx={idx}
                operacao={operacao}
                openIndex={openIndex}
                pecaIdx={pecaIdx}
                pecaEntregaId={pecaEntregaId}
                expeditionIndex={expeditionIndex}
                setExpeditionIndex={setExpeditionIndex}
                form={form}
                setPecasToDisplay={setPecasToDisplay}
            /> : null}
            
        </div>
    )



}